import React, { useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import { checkPrivileges } from "../../../config/Global";
import { Button, Result } from "antd";
import ListTable from "./components/ListTable";
import { AppDispatch } from "../../../store/app";
import { useDispatch } from "react-redux";
import { fetchListErrorCode } from "../../../store/ErrorCodeSlice";
import AddErrorCode from "./components/AddErrorCode";
import EditErrorCode from "./components/EditErrorCode";
import DeleteErrorCode from "./components/DeleteErrorCode";

const ErrorCodes: React.FC = () => {
  const userDetails = localStorage.getItem("userDetails");
  const userRoles = userDetails && JSON.parse(userDetails)?.roles;
  const dispatch: AppDispatch = useDispatch();

  const [openAddModal, setOpenAddModal] = useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [dataEditModal, setDataEditModal] = useState<any>();
  const [openDeleteRequest, setOpenDeleteRequest] = useState<boolean>(false);
  const [dataDeleteRequest, setDataDeleteRequest] = useState<any>();

  const [listData, setListData] = useState<any[]>([]);
  const [totalData, setTotalData] = useState<any>(0);
  const [tableloading, setTableLoading] = useState<boolean>(false);
  const [savePayload, setSavePayload] = useState<any>();
  const [paginationData, setPaginationData] = useState<any>({
    current: 1,
    page_size: 10,
  });

  const getList = (data?: any) => {
    setTableLoading(true);
    const payload = {
      ...data,
      current: data?.current ?? paginationData?.current ?? 1,
      page_size: data?.page_size ?? paginationData?.page_size ?? 10,
    };
    setSavePayload(payload);
    dispatch(fetchListErrorCode(payload))
      .then((res: any) => {
        setListData(res?.data?.data);
        setTotalData(res?.data?.total_data ?? res?.data?.data?.length);
        setTableLoading(false);
      })
      .catch(() => {
        setTableLoading(false);
        setListData([]);
        setTotalData(0);
      });
  };

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddModal = () => {
    setOpenAddModal(!openAddModal);
  };

  const handleDeleteRequest = (data?: any) => {
    setOpenDeleteRequest(!openDeleteRequest);
    if (data) {
      setDataDeleteRequest(data);
    }
  };
  const handleEditModal = (data?: any) => {
    setOpenEditModal(!openEditModal);
    if (data) {
      setDataEditModal(data);
    }
  };

  return (
    <>
      <ToolBar
        title={"Portability Error Codes"}
        children={
          <>
            {checkPrivileges(userRoles, "admin") ? (
              <Button type="primary" onClick={handleAddModal}>
                Add New
              </Button>
            ) : null}
          </>
        }
      />
      {checkPrivileges(userRoles, "admin") ? (
        <ListTable
          listData={listData}
          setListData={setListData}
          totalData={totalData}
          tableloading={tableloading}
          setTableLoading={setTableLoading}
          paginationData={paginationData}
          setPaginationData={setPaginationData}
          getList={getList}
          savePayload={savePayload}
          handleEditModal={handleEditModal}
          handleDeleteRequest={handleDeleteRequest}
        />
      ) : (
        <Result
          status="403"
          title="403"
          subTitle="You don't have enough permission to perform this action."
        />
      )}
      {openAddModal ? (
        <AddErrorCode
          handleAddModal={handleAddModal}
          openAddModal={openAddModal}
          getList={getList}
        />
      ) : null}

      {openEditModal ? (
        <EditErrorCode
          handleEditModal={handleEditModal}
          dataEditModal={dataEditModal}
          openEditModal={openEditModal}
          getList={getList}
        />
      ) : null}

      {openDeleteRequest ? (
        <DeleteErrorCode
          open={openDeleteRequest}
          deleteValues={dataDeleteRequest?.code}
          name={"Error Code"}
          title={dataDeleteRequest?.code}
          getList={getList}
          close={handleDeleteRequest}
        />
      ) : null}
    </>
  );
};

export default ErrorCodes;
